module.exports = __webpack_public_path__ + "media/images/site/CTERCEIRAO_DIFERENCIAL-e2f8b4b11f62c9a24add653c8aa5d83a.jpg";